import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrls: ['./text-area.component.scss']
})
export class TextAreaComponent {

  @Input() styleClass: string;

  constructor() { }
}
